import React from 'react';
import { Checkbox, FormControl, InputLabel, MenuItem, OutlinedInput, Select } from '@material-ui/core';
import useForm from 'react-hook-form';
import useDocument from '../../../hooks/useDocument';
import { EMAIL_PATTERN, NAME_MIN_LENGTH, NAME_PATTERN, NUMBER_PATTERN } from '../../../state/constants/appConstants';
import Alert from '../../atoms/alert/alert';
import DataPolicy from '../data-policy/data-policy';
import InputMaterial from '../../atoms/input-material/input-material';
import Icon from '../../atoms/Icon/Icon';
import useHomeLinkMode from '../../../hooks/useHomeLinkMode';
import './modal-auth-prospect.scss';
import ButtonLoading from '../buttonLoading/buttonLoading';
import Button from '../../atoms/Button/Button';
import ArticleService from '../../../services/articles';
import RegisterService from '../../../services/register';

const ModalAuthProspect = props => {
    const documentInfo = useDocument();
    const [documentType, setDocumentType] = React.useState(documentInfo?.tipoDeDocumento[0]?.value);
    const [terms, setTerms] = React.useState(false);
    const [politics, setPolitics] = React.useState(false);
    const [errorTerms, setErrorTerms ] = React.useState(false)
    const [errorPolitics, setErrorPolitics ] = React.useState(false)
    const [isLoaderVisible, setLoaderVisible] = React.useState(false);
    const [endpointErrors, setEndpointErrors] = React.useState({ email: false, cellphone: false, document: false });
    const { homeLink } = useHomeLinkMode();

    const {
        register,
        handleSubmit,
        triggerValidation,
        setValue,
        errors,
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            email: props.inputValue && (EMAIL_PATTERN).test(props.inputValue) ? props.inputValue : "",
            cellphone: props.inputValue && !(EMAIL_PATTERN).test(props.inputValue) ? props.inputValue : ""
        }
    });

    const handleDataLayerError = (error = "") => {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            'event': 'ga_event_consultorio',
            'category': 'Academia TENA',
            'action': props.isComment ? 'Opinión ::Validar datos' : 'Ver contenido:: Validar datos',
            'label': error
        })
    }
    

    const isValidTerms = ()=>{
        if(!terms){
            setErrorTerms(true)
            return false
        }
        if(!politics){
            setErrorPolitics(true)
            return false
        }
        return true
    }

    //Handle send form
    const onSubmit = async data => {

        if(isValidTerms()){
        window.dataLayer = window.dataLayer || []
        setLoaderVisible(true);
        let payload = {
            email: data.email,
            cellPhone: process.env.COUNTRY_PHONE_PREFIX + data.cellphone
        }

        ArticleService.validateEmailAndCell(payload).then(resp => {
            if (resp.status === 400) {
                props.isWebinar && handleDataLayerError(resp.userMessage)
                setLoaderVisible(false);
                switch (resp.errorCode) {
                    case "DEM011":
                        setEndpointErrors({ cellphone: true })
                        break;
                    case "DEM012":
                        setEndpointErrors({ email: true })
                        break;
                    default:
                        break;
                }
            }

            //If dont exist cellphone number and email continous with the next validation
            else if (resp.status === 200) {
                payload = {
                    ...payload,
                    name: data.name,
                    lastName: data.lastname,
                    countryRegisterId: process.env.COUNTRY_CODE,
                    tycAccepted: 1,
                    uytdAccepted: 1,
                    typeId: documentType,
                    numberId: data.document
                }
                RegisterService.checkDocument(payload).then(resp => resp).then(resp2 => {

                    //if document don't exist, register de prospect user
                    if (resp2.status === 200) {

                        RegisterService.registerLeaflet(payload).then(resp => {
                            // console.log("🚀 ~ file: leaflet-card.jsx ~ line 417 ~ RegisterService.registerLeaflet ~ resp", resp)
                            setLoaderVisible(false);
                            if (resp.status === 200) {
                                if (props.isWebinar) {
                                    window.dataLayer.push({
                                        'event': 'ga_event_consultorio',
                                        'category': 'Academia TENA',
                                        'action': props.isComment ? 'Opinión' : 'Ver contenido',
                                        'label': props.buttonProspect,
                                        'value': ''
                                    });
                                }
                                props.setProspectEmail(resp.data.email)
                                props.hideModal();
                            }
                        })

                    } else if (resp2.status === 400) {
                        props.isWebinar && handleDataLayerError(resp2.userMessage)
                        setLoaderVisible(false);
                        setEndpointErrors({ document: true })
                        return false
                    }
                })
            }
        })
            .catch(err => { setLoaderVisible(false); console.log(err) })
               
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="f-form-prospect">
            <InputMaterial
                errors={[]}
                name="name"
                type="text"
                autoComplete={false}
                classes="f-form-input"
                label="Nombres *"
                register={register({
                    required: { value: true, message: "El nombre es requerido." },
                    pattern: { value: NAME_PATTERN, message: "El nombre ingresado es inválido." },
                    minLength: { value: NAME_MIN_LENGTH, message: "El nombre debe tener mínimo 3 caracteres." }
                })}
            />
            <InputMaterial
                errors={[]}
                name="lastname"
                type="text"
                autoComplete={false}
                classes="f-form-input"
                label="Apellidos *"
                register={register({
                    required: { value: true, message: "Los apellidos son requeridos." },
                    pattern: { value: NAME_PATTERN, message: "Los apellidos ingresados son inválidos." },
                    minLength: { value: NAME_MIN_LENGTH, message: "Los apellidos deben tener mínimo 3 caracteres." }
                })}
            />
            <FormControl
                variant="outlined"
                className="f-select-input"
            >
                <Select
                    name='documentType'
                    id='documentType'
                    value={documentType}
                    onChange={e => setDocumentType(e.target.value)}
                    input={<OutlinedInput labelWidth={0} name="documentType" id="documentType" />}

                >
                    {documentInfo?.tipoDeDocumento?.map((item, index) => (
                        <MenuItem key={index} value={item.value}>{item.name}</MenuItem>
                    ))}
                </Select>
                <Icon icon="icon-chevron-down lonchmara" size="0-7" tagtype="i" />
            </FormControl>

            <InputMaterial
                change={e => {
                    setEndpointErrors({ document: false });
                    triggerValidation({ name: e.target.name });
                }}
                errors={[]}
                name="document"
                type="text"
                autoComplete={false}
                classes="f-form-input"
                label={documentInfo?.inputNumeroDeDocumento}
                register={register({
                    required: { value: true, message: "El documento es requerido." },
                    minLength: { value: 5, message: "El documento debe tener mínimo 5 caracteres." },
                    maxLength: { value: 15, message: "El documento debe tener máximo 15 caracteres." },
                })}
            />
            <InputMaterial
                change={e => {
                    setEndpointErrors({ email: false });
                    triggerValidation({ name: e.target.name });
                }}
                errors={[]}
                name="email"
                type="text"
                autoComplete={false}
                classes="f-form-input"
                label="Correo electrónico *"
                // messageError={isEmailActive ? errorMessagge : null}
                register={register({
                    required: { value: true, message: "El correo es requerido." },
                    minLength: { value: 8, message: "Este campo debe contener por lo menos 8 dígitos." },
                    maxLength: { value: 50, message: "Este campo debe contener máximo 50 dígitos." },
                    pattern: { value: EMAIL_PATTERN, message: "El correo ingresado es inválido." }
                })}
            />
            <InputMaterial
                change={e => {
                    if (e.target.value !== null && e.target.value.length > 0) {
                        let newValue = e.target.value.replace(/\D/g, '');
                        setValue("cellphone", newValue);
                    }
                    setEndpointErrors({ cellphone: false });
                    triggerValidation({ name: e.target.name });
                }}
                errors={[]}
                name="cellphone"
                type="text"
                autoComplete={false}
                classes="f-form-input"
                label="Celular *"
                register={register({
                    required: { value: true, message: "Tu número celular es requerido." },
                    pattern: { value: NUMBER_PATTERN, message: "Ingresa sólo números." },
                    minLength: { value: process.env.CELL_DIG, message: `Un número celular debe tener ${process.env.CELL_DIG} dígitos.` },
                    maxLength: { value: process.env.CELL_DIG, message: `Un número celular debe tener ${process.env.CELL_DIG} dígitos.` },
                })}
            />
            <div className="f-terms-prospect">
                <div className="f-terms-wrapper">
                    <Checkbox
                        checked={politics}
                        onChange={event => {
                            setErrorPolitics(false) 
                            setPolitics(event.target.checked) 
                        }}
                        value={politics}
                        className={"f-terms-checkbox"}
                        name="policy"
                    />
                    <div className="f-terms"><p> He leído y autorizo la <a rel="noopener noreferrer" target="_blank" href={homeLink + "politica-de-privacidad/"} >política de uso de datos </a></p></div>
                </div>
                <div className="f-terms-wrapper">
                    <Checkbox
                        checked={terms}
                        onChange={event => {
                            setErrorTerms(false) 
                            setTerms(event.target.checked) 
                        }}
                        value={terms}
                        name="terms"
                        className={"f-terms-checkbox"}
                    />
                    <div className="f-terms"><p>He leído y autorizo los <a rel="noopener noreferrer" target="_blank" href={homeLink + "terminos-y-condiciones/"} >términos y condiciones </a> </p> </div>
                </div>
            </div>
            <div className="f-data-policy-container">
                <DataPolicy />
            </div>
            {(errors.name || errors.lastname || errors.cellphone || errorPolitics || errorTerms || Object.values(endpointErrors).includes(true)) &&
                <Alert alertType="error-leaflet" description={
                    errors.name ? errors.name.message :
                        errors.lastname ? errors.lastname.message :
                            errors.cellphone ? errors.cellphone.message :
                                endpointErrors.cellphone ? "Éste número ya se encuentra registrado." :
                                    endpointErrors.email ? "Éste correo electrónico ya se encuentra registrado." :
                                        endpointErrors.document ? "Éste documento ya se encuentra registrado." :
                                            errorPolitics ? "Debes aceptar politicas de uso de datos para continuar." :
                                                errorTerms ? "Debes aceptar términos y condiciones para continuar." :
                                                    ""} />}
            <div className="f-button-wrapper">
                <ButtonLoading
                    button={
                        <Button
                            type="input"
                            classname="f-button f-button--primary"
                            text={props.buttonProspect}
                        />
                    }
                    isShowingLoader={isLoaderVisible}
                    bgClass="primary"
                />
            </div>
        </form>)
};

export default ModalAuthProspect;